import type { FormSubmission } from "@/types/form";

const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8080";
const CRM_SUBMIT_API_KEY = import.meta.env.VITE_CRM_SUBMIT_API_KEY || "";

const TIMEOUT_MS = 30_000;

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const errorMessage = `HTTP ${response.status}: ${response.statusText}`;
    const contentType = response.headers.get("content-type");
    if (contentType?.includes("application/json")) {
      const error = await response.json();
      throw new Error(error.error || error.message || errorMessage);
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export const api = {
  async submitForm(
    data: FormSubmission,
    signal?: AbortSignal,
  ): Promise<{ id: string; createdAt: string }> {
    if (!CRM_SUBMIT_API_KEY) {
      throw new Error("CRM submit API key is not configured");
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(new Error("Request timed out")), TIMEOUT_MS);

    if (signal) {
      signal.addEventListener("abort", () => controller.abort(signal.reason), { once: true });
    }

    try {
      const response = await fetch(`${API_BASE_URL}/bookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": CRM_SUBMIT_API_KEY,
        },
        body: JSON.stringify(data),
        signal: controller.signal,
      });
      return handleResponse(response);
    } finally {
      clearTimeout(timeoutId);
    }
  },
};
